import { useQuery } from 'react-query';
import { fetchDisneyOriginals } from '../services/api';

export const useDisneyOriginals = options => {
  return useQuery('disneyOriginals', fetchDisneyOriginals, options);
};
